import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { Context } from "../context/MainContext";
import HeaderImg from "../components/HeaderImg";
import { Input, Label } from "../components/styledComponent/formInputs";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import { initEnrollment } from "../api/usersApi";
import PayWithPaystackEnroll from "../components/PayWithPaystackEnroll";
// import PayWithPaystackEnroll from "../components/PayWithPaystackEnroll";

const CheckoutEnroll = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(Context);

  const program = state?.program;
  const duration = state?.duration;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [inputError, setInputError] = useState({});
  const [loading, setLoading] = useState(false);
  const [proceedPayment, setProceedPayment] = useState(false);
  const [enrollData, setEnrollData] = useState(null); // holds reference + email + amount

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!program) navigate("/training");
  }, [program, user?.id, navigate]);

  useEffect(() => {
    if (!user?.id) {
      navigate("/login?checkout=enroll");
    }
  }, [user, navigate]);

  // Strip non-numeric characters to get raw amount (e.g "₦150,000" → 150000)
  const rawAmount = parseInt(
    program?.prices?.[duration]?.replace(/[^0-9]/g, "") || "0",
  );

  const validate = () => {
    const errors = {};
    if (!firstName || firstName.length < 2)
      errors.firstName = "First name is required (min 2 characters)";
    if (!lastName || lastName.length < 2)
      errors.lastName = "Last name is required (min 2 characters)";
    if (!phone || phone.length < 7)
      errors.phone = "Valid phone number is required";
    if (!email || !email.includes("@"))
      errors.email = "Valid email is required";
    setInputError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInitPayment = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const data = {
        userId: user?.id || null,
        courseName: program?.title,
        amount: rawAmount,
        period: `${duration} months`,
        firstName,
        lastName,
        phone,
        email,
      };

      const res = await initEnrollment(data);

      if (res.data?.reference) {
        setEnrollData({
          reference: res.data.reference,
          email,
          amount: rawAmount * 100, // kobo for Paystack config
        });
        setProceedPayment(true);
      } else {
        toast.error("Error initiating payment, please try again");
      }
    } catch (err) {
      const message =
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        err.toString();
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentSuccess = () => {
    navigate("/account?tab=enroll");
  };

  if (!program) return null;

  return (
    <div className="checkout">
      <HeaderImg title="Program Enrollment" />

      <div className="checkout__main">
        {/* LEFT — Form */}
        <div className="checkout__left">
          <h2>Your Details</h2>
          <form className="checkout__left__form">
            <div className="checkout__left__form__inputCon">
              <div className="checkout__left__form__inputCon__item">
                <Label htmlFor="firstName">
                  First name <span>*</span>
                </Label>
                <Input
                  id="firstName"
                  type="text"
                  value={firstName}
                  error={!!inputError.firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  disabled={proceedPayment}
                />
                {/* {inputError.firstName && (
                  <small className="input-error">{inputError.firstName}</small>
                )} */}
              </div>

              <div className="checkout__left__form__inputCon__item">
                <Label htmlFor="lastName">
                  Last name <span>*</span>
                </Label>
                <Input
                  id="lastName"
                  type="text"
                  value={lastName}
                  error={!!inputError.lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  disabled={proceedPayment}
                />
                {/* {inputError.lastName && (
                  <small className="input-error">{inputError.lastName}</small>
                )} */}
              </div>
            </div>

            <div className="checkout__left__form__input">
              <Label htmlFor="phone">
                Phone number <span>*</span>
              </Label>
              <Input
                id="phone"
                type="number"
                value={phone}
                error={!!inputError.phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={proceedPayment}
              />
              {/* {inputError.phone && (
                <small className="input-error">{inputError.phone}</small>
              )} */}
            </div>

            <div className="checkout__left__form__input">
              <Label htmlFor="email">
                Email address <span>*</span>
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                error={!!inputError.email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={proceedPayment}
              />
              {/* {inputError.email && (
                <small className="input-error">{inputError.email}</small>
              )} */}
            </div>
          </form>
        </div>

        {/* RIGHT — Summary + Payment */}
        <div className="checkout__right">
          <h2>Enrollment Summary</h2>

          <div className="cart__main__total" style={{ marginTop: 47 }}>
            <div className="cart__main__total__part">
              <b>Program</b>
              <b>Price</b>
            </div>

            <div className="cart__main__total__part">
              <span>
                {program.title} <b>× {duration} months</b>
              </span>
              <span>{program.prices?.[duration]}</span>
            </div>

            <div className="cart__main__total__part">
              <b>Duration</b>
              <b>{duration} months</b>
            </div>

            <div className="cart__main__total__part">
              <b>Total</b>
              <b>{program.prices?.[duration]}</b>
            </div>
          </div>

          <PayWithPaystackEnroll
            loading={loading}
            proceedPayment={proceedPayment}
            handleInitPayment={handleInitPayment}
            enrollData={enrollData}
            onPaymentSuccess={handlePaymentSuccess}
          />

          {/* {!proceedPayment && (
            <button
              className="btn-outline"
              style={{ width: "100%", marginTop: 12 }}
              onClick={() => navigate("/training")}
            >
              ← Back to Programs
            </button>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default CheckoutEnroll;
